<template>
  <!-- Sidebar -->
  <nav class="sidebar" select-cy="nav">
    <router-link class="flex py-4 px-4 bg-white rounded-b justify-between wwf-logo" to="/">
      <img class="cursor-pointer h-20" src="~@/assets/img/logo.svg" />
      <!-- <div class="brand">
        <div class="title">PandaVue</div>
        <div class="subtitle">WWF-Australia</div>
      </div> -->
    </router-link>
    <div class="list flex flex-col h-full justify-between">
      <div class="mt-3">
        <!-- HOME -->
        <router-link class="link" :class="{ selected: isSelected('/home') }" to="/home">
          <i class="icn icn-home"></i>
          <span>Home</span>
        </router-link>

        <!-- SUPPORTER -->
        <router-link
          class="link"
          :class="{ selected: isSelected('/supporters') }"
          to="/supporters"
          select-cy="supporters"
        >
          <i class="icn icn-support"></i>
          <span>Supporters</span>
        </router-link>

        <!-- REPORTING -->
        <!-- <router-link
          class="link"
          :class="{ selected: isSelected('/reports') }"
          to="/reports"
          v-if="hasAccess(modules.PBI_REPORT_VIEWER)"
        >
          <i class="icn icn-presentation-chart-line"></i>
          <span>Reporting</span>
        </router-link> -->

        <!-- OVERVIEW -->
        <router-link class="link" :class="{ selected: isSelected('/overview') }" to="/overview">
          <i class="icn icn-chart-pie"></i>
          <span>Overview</span>
        </router-link>

        <!-- EXPORTS DATA -->
        <router-link class="link" :class="{ selected: isSelected('/exports-data') }" to="/exports-data">
          <i class="icn icn-document-download"></i>
          <span>Exports Data</span>
        </router-link>

        <!-- DONATIONS -->
        <!-- <router-link
          class="link"
          :class="{ selected: isSelected('/donations-over-the-phone') }"
          to="/donations-over-the-phone"
          v-if="hasAccess(modules.DOTP)"
        >
          <i class="icn icn-table"></i>
          <span>Donations</span>
        </router-link> -->
      </div>

      <!-- Settings Section -->
      <div class="pb-4">
        <div
          class="section"
          :class="{
            selected:
              isSelected('/reports-management') ||
              isSelected('/companies') ||
              isSelected('/users') ||
              isSelected('/security-groups') ||
              isSelected('/roles'),
          }"
          @click="section === 'settings' ? (section = null) : (section = 'settings')"
          select-cy="settings"
          v-if="hasAccess(settingModules) || isSuperAdmin"
        >
          <div class="icon"><i class="icn icn-cog"></i></div>
          <span>Settings</span>
          <div class="icon chevron" v-if="section != 'settings'">
            <i class="icn icn-chevron-up"></i>
          </div>
          <div class="icon chevron" v-if="section === 'settings'">
            <i class="icn icn-chevron-down"></i>
          </div>
        </div>
        <div class="sub-links" v-if="section === 'settings'">
          <!-- PBI REPORTS -->
          <!-- <router-link
            class="link"
            :class="{ selected: isSelected('/reports-management') }"
            to="/reports-management"
            select-cy="reports"
            v-if="hasAccess(modules.PBI_REPORT)"
          >
            <i class="icn icn-document-report"></i>
            <span>Reports</span>
          </router-link> -->

          <!-- COMPANIES -->
          <!-- <router-link
            class="link"
            :class="{ selected: isSelected('/companies') }"
            to="/companies"
            select-cy="companies"
            v-if="hasAccess(modules.COMPANY)"
          >
            <i class="icn icn-office-building"></i>
            <span>Companies</span>
          </router-link> -->

          <!-- USERS -->
          <router-link
            class="link"
            :class="{ selected: isSelected('/users') }"
            to="/users"
            select-cy="users"
            v-if="hasAccess(modules.USER)"
          >
            <i class="icn icn-users"></i>
            <span>Users</span>
          </router-link>

          <!-- SECURITY GROUP -->
          <!-- <router-link
            class="link"
            :class="{ selected: isSelected('/security-groups') }"
            to="/security-groups"
            select-cy="security-groups"
            v-if="hasAccess(modules.SECURITY_GROUP)"
          >
            <i class="icn icn-user-group"></i>
            <span>Security Groups</span>
          </router-link> -->

          <!-- ROLES -->
          <!-- <router-link
            class="link"
            :class="{ selected: isSelected('/roles') }"
            to="/roles"
            select-cy="roles"
            v-if="isSuperAdmin"
          >
            <i class="icn icn-lock-open"></i>
            <span>Roles</span>
          </router-link> -->
        </div>

        <div class="link cursor-pointer" @click="logout()">
          <i class="icn icn-logout"></i>
          <span>Sign out</span>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { MODULE, PERMISSION } from '@/helpers/security';
import { mapGetters } from 'vuex';

export default {
  name: 'Menu',

  data() {
    return {
      isExpanded: false,
      section: null,
      // Roles are for super admins only
      settingModules: [MODULE.USER, MODULE.COMPANY, MODULE.SECURITY_GROUP, MODULE.PBI_REPORT],
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    isSuperAdmin() {
      return this.user && this.user.isSuperAdmin;
    },
    ...mapGetters({
      user: ['auth/currentUser'],
    }),
    modules() {
      return MODULE;
    },
    permissions() {
      return PERMISSION;
    },
  },

  methods: {
    isSelected(url) {
      // Avoid confusions between routes starting the same
      const temp = this.$route.path.slice(1);
      const idx = temp.indexOf('/');
      const base = `/${temp.slice(0, idx >= 0 ? idx : undefined)}`;
      return base === url;
    },
    logout() {
      this.$store.dispatch('auth/logout');
    },
    toggleReports() {
      this.showReports = !this.showReports;
    },
    hasAccess(moduleCode) {
      if (Array.isArray(moduleCode)) {
        return (
          this.user &&
          (this.user.isSuperAdmin ||
            (this.user.permissions &&
              Object.keys(this.user.permissions).filter((e) => moduleCode.includes(parseInt(e))).length > 0))
        );
      } else {
        return this.user && (this.user.isSuperAdmin || (this.user.permissions && this.user.permissions[moduleCode]));
      }
    },
  },
};
</script>
<style scoped>
.sidebar {
  @apply z-10 flex flex-shrink-0 flex-col w-56 px-4 pb-2 bg-gray-700 shadow overflow-hidden;
}

.list {
  @apply bg-gray-700 overflow-y-auto overflow-x-hidden pt-4;

  &::-webkit-scrollbar {
    width: 5px;
    @apply bg-gray-50 rounded-b;
  }

  &::-webkit-scrollbar-thumb {
    @apply bg-gray-200;
  }
}

.section {
  @apply flex items-center py-2 px-2 mb-2 w-full font-medium text-menu-gray rounded cursor-pointer hover:text-white hover:bg-gray-800 transition;

  span {
    @apply flex-grow;
  }

  &.selected {
    @apply bg-gray-800 text-white;
  }
}

.sub-links {
  @apply pl-4;
}

.icon {
  @apply flex items-center;

  .icn {
    @apply mr-2;
  }

  &.chevron {
    .icn {
      @apply ml-2 mr-0;
    }
  }
}

.link {
  @apply flex items-center py-2 px-2 mb-2 rounded font-medium text-menu-gray hover:text-white hover:bg-gray-800 transition;
  .icn {
    @apply mr-2;
  }
}

.space {
  @apply flex items-center py-2 px-2 mb-2 text-gray-500;
}

.link.selected {
  @apply bg-gray-800 text-white;
}

.sub-menu {
  @apply origin-bottom-left absolute bottom-16 w-44 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 transform opacity-0 scale-95;
  @apply transition ease-in duration-75;
}

.sub-menu.expanded {
  @apply transform opacity-100 scale-100;
  @apply transition ease-out duration-200;
}

.sub-link {
  @apply block px-4 py-2 text-gray-700 hover:bg-gray-100;
  &:hover {
    cursor: pointer;
  }
}

.brand {
  @apply flex flex-col justify-center;
}

.brand .title {
  @apply text-xl font-bold;
}

.brand .subtitle {
  @apply text-xs;
}

.wwf-logo {
  max-width: 80px;
}
</style>
